import { Resource } from './Resource';
import { BlendState } from './BlendState';

export class BlendResource extends Resource<BlendState> {
  static readonly TypeId: string = 'blend';

  constructor(id: string) {
    super(id);
  }

  get typeId(): string {
    return BlendResource.TypeId;
  }
}
